import { useEffect } from 'react'
import {
  BiDetail,
  BiUserCircle,
  BiBot,
  BiBrain,
  BiGrid,
  BiShoppingBag,
  BiBroadcast,
  BiCog,
  BiBuoy,
  BiLinkAlt,
  BiTerminal,
  BiShieldQuarter,
  BiRocket,
} from 'react-icons/bi'
import {
  GiProcessor,
} from 'react-icons/gi'

const SidebarNav = ({ onClick, navItems, activeItem, rights }) => {

  const iconsMap = {
    BiDetail,
    BiUserCircle,
    BiBot,
    BiBrain,
    BiGrid,
    BiShoppingBag,
    BiBroadcast,
    BiCog,
    BiBuoy,
    BiLinkAlt,
    GiProcessor,
    BiTerminal,
    BiShieldQuarter,
    BiRocket,
  }

  useEffect(() => {
    // console.log(rights)
  }, [])

  const renderItem = (item, DynamicIcon) => (
    <li
      key={item.name}
      className={activeItem === item.name ? 'active' : ''}
      data-item-name={item.name}
    >
      <a data-item-path={item.path} onClick={onClick}>
        <DynamicIcon key={item.icon} size={36} />
        {item.name}
      </a>
    </li>
  )

  const renderItems = (item) => {
    const DynamicIcon = iconsMap[item.icon]

    if (item.checkRight) {
      // item.right: single right OR an array of rights (any one grants access).
      const allowed = Array.isArray(item.right)
        ? item.right.some((r) => rights.includes(r))
        : item.right && rights.includes(item.right)
      if (allowed) {
        return renderItem(item, DynamicIcon)
      } else {
        return null
      }
    } else {
      return renderItem(item, DynamicIcon)
    }
  }

  return <ul className="sidebar-nav">{navItems.map(renderItems)}</ul>
}

export default SidebarNav
